<div class="avatars-container">
  <span *ngFor="let a of avatars" class="avatar-container" (click)="onAvatarSelected(a)"
      [class]="avatar === a ? 'selected': ''">
    <img src="/assets/imgs/{{a}}.jpg" class="avatar"/>
  </span>
</div>
